/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable eqeqeq */

import React, { useEffect, useState } from "react";
import {
  collection,
  getDocs,
  deleteDoc,
  doc,
  query,
  where,
} from "firebase/firestore";
import { auth, db } from "../../../firebase";
import { states } from "../../../data/usStates";

import { Col, Dropdown, Form, Input, Row, Select, Space, Table } from "antd";
import { SlOptions } from "react-icons/sl";

import PageHeading from "../../../components/common/PageHeading";

import "./PropertyGroups.css";
import RightBar from "../../../components/common/RightBar";
import Footer from "../../../components/common/Footer";
import ConfirmationBox from "../../../components/common/ConfirmationBox";
import { toast } from "react-hot-toast";
import RightBarMethod from "../../../components/common/RightBar/RightBarMethod";
import FilterContainer from "../../../components/common/FilterContainer";
import { useNavigate } from "react-router-dom";
import { useAuthState } from "react-firebase-hooks/auth";

const PropertyGroupsRightBar = [
  RightBarMethod("Tasks", "t1", <i className="fa-solid fa-star"></i>, [
    RightBarMethod(
      "New Property Group",
      "1",
      "",
      "",
      "/generalsettings/new-property-groups"
    ),
  ]),
  RightBarMethod(
    "REPORTS",
    "t2",
    <i className="fa-solid fa-chart-column"></i>,
    [
      RightBarMethod(
        "Property Group Directory",
        "3",
        "",
        "",
        "/generalsettings/screening-criteria/screening-criteria"
      ),
    ]
  ),
];

function PropertyGroups() {
  const [user, loading] = useAuthState(auth);
  const [companyName, setCompanyName] = useState("");
  const [isCompanyNameFetched, setIsCompanyNameFetched] = useState(false);

  const [sortedInfo, setSortedInfo] = useState({});
  const [recordId, setRecordId] = useState(0);
  const [propertyGroups, setPropertyGroups] = useState([]);
  const [properties, setProperties] = useState([]);
  const [users, setUsers] = useState([]);
  const [userPropertyPermissions, setUserPropertyPermissions] = useState([]);
  const [isConfirmationBoxOpen, setIsConfirmationBoxOpen] = useState(false);
  const [isDelete, setIsDelete] = useState(false);
  const [state, setState] = useState("");
  const [zipCodeFilter, setZipCodeFilter] = useState("");
  const [addressFilter, setAddressFilter] = useState("");
  const [propertyGroupFilter, setPropertyGroupFilter] = useState("");
  const [userEmailFilter, setUserEmailFilter] = useState("");

  const navigate = useNavigate();

  const fetchCompanyName = async () => {
    try {
      const usersRef = collection(db, "allUsers");
      const userData = query(usersRef, where("uid", "==", user?.uid));
      const querySnapshot = await getDocs(userData);
      querySnapshot.forEach((doc) => {
        const res = doc.data();
        setCompanyName(res.companyName);
      });
      setIsCompanyNameFetched(true);
    } catch (error) {
      console.log("Error getting company name: ", error);
    }
  };
  useEffect(() => {
    fetchCompanyName();
  }, [user, loading]);

  useEffect(() => {
    if (!isCompanyNameFetched) return;
    const fetchPropertyGroups = async () => {
      try {
        const propertyGroupRef = collection(
          db,
          "companies",
          companyName,
          "propertyGroups"
        );
        const snapshot = await getDocs(propertyGroupRef);
        const fetchedData = snapshot.docs.map((doc) => ({
          id: doc.id,
          propertiesData: properties.filter((item1) =>
            snapshot.docs.some(
              (item2) =>
                item2?._document.data.value.mapValue.fields?.id !== item1?.id
            )
          ),
          ...doc.data(),
        }));
        setPropertyGroups(fetchedData);
      } catch (err) {
        console.error(err);
        alert(err.message);
      }
    };
    fetchPropertyGroups();
  }, [isDelete, properties, companyName, isCompanyNameFetched]);

  useEffect(() => {
    if (!isCompanyNameFetched) return;
    const fetchProperties = async () => {
      try {
        const propertyUnitRef = collection(
          db,
          "companies",
          companyName,
          "properties"
        );
        const snapshot = await getDocs(propertyUnitRef);

        const fetchedData = snapshot.docs.map((doc) => ({
          id: doc.id,
          address:
            doc.data().propertyNameAddress.propertyName +
            " - " +
            doc.data().propertyNameAddress.propertyAddressOne +
            " - " +
            doc.data().propertyNameAddress.city +
            ", " +
            doc.data().propertyNameAddress.country +
            "-" +
            doc.data().propertyNameAddress.state,
          ...doc.data(),
        }));
        setProperties(fetchedData);
      } catch (err) {
        console.error(err);
        alert(err.message);
      }
    };
    fetchProperties();
  }, [companyName, isCompanyNameFetched]);

  useEffect(() => {
    if (!isCompanyNameFetched) return;
    const fetchUsers = async () => {
      try {
        const userRef = collection(db, "companies", companyName, "users");
        const snapshot = await getDocs(userRef);
        const fetchedData = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setUsers(fetchedData);
      } catch (err) {
        console.error(err);
        alert(err.message);
      }
    };
    fetchUsers();
  }, [companyName, isCompanyNameFetched]);

  useEffect(() => {
    const userProp = users.find(
      (item) => item.profile.email === userEmailFilter
    );
    console.log("....", userProp);
    setUserPropertyPermissions(userProp);
  }, [userEmailFilter]);

  const handleChange = (pagination, filters, sorter) => {
    console.log("Various parameters", pagination, filters, sorter);
    setSortedInfo(sorter);
  };

  const handleMenuClick = ({ key }) => {
    if (key == 2) {
      setIsConfirmationBoxOpen(true);
    }
    if (key == 1) {
      navigate(`/generalsettings/new-property-groups/${recordId}`);
    }
  };

  const deletePropertyGroup = async (id) => {
    try {
      const propertyGroupRef = doc(
        db,
        "companies",
        companyName,
        "propertyGroups",
        id
      );
      await deleteDoc(propertyGroupRef);
      toast.success("property Group Deleted Successfully");
      setIsDelete(true);
      setIsConfirmationBoxOpen(false);
    } catch (err) {
      console.error(err);
      alert(err.message);
    }
  };

  console.log("propt", propertyGroups);
  const filteredDataSource = propertyGroups.filter(
    (record) =>
      (state === "" ||
        record?.propertiesData?.some((value) =>
          value?.propertyNameAddress?.state
            ?.toLowerCase()
            .includes(state.toLowerCase())
        )) &&
      (zipCodeFilter === "" ||
        record?.propertiesData?.some((value) =>
          value?.propertyNameAddress?.zipCode
            ?.toLowerCase()
            .includes(zipCodeFilter.toLowerCase())
        )) &&
      (addressFilter === "" ||
        record?.propertiesData?.some((value) =>
          value?.propertyNameAddress?.propertyAddressOne
            ?.toLowerCase()
            .includes(addressFilter.toLowerCase())
        )) &&
      (userEmailFilter === "" ||
        userPropertyPermissions?.propertyPermission?.some((value) =>
          record?.propertyGroupName?.toLowerCase().includes(value.toLowerCase())
        ))
  );

  const items = [
    {
      key: "1",
      label: "Edit",
    },
    {
      key: "2",
      label: <span className="delete">Delete</span>,
    },
  ];

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      render: (_, record) => (
        <span className="onclick-text">{record?.propertyGroupName}</span>
      ),
      sorter: (a, b) => a.name.length - b.name.length,
      sortOrder: sortedInfo.columnKey === "name" ? sortedInfo.order : null,
      ellipsis: true,
    },
    {
      title: "Users",
      dataIndex: "user",
      key: "user",
      render: (text) => <span className="onclick-text">{text}</span>,
      sorter: (a, b) => a.users.length - b.users.length,
      sortOrder: sortedInfo.columnKey === "user" ? sortedInfo.order : null,
      ellipsis: true,
    },
    {
      title: "Properties",
      dataIndex: "property",
      key: "property",
      render: (_, record) => (
        <span className="onclick-text">{record?.properties.length}</span>
      ),
      sorter: (a, b) => a.property.length - b.property.length,
      sortOrder: sortedInfo.columnKey === "property" ? sortedInfo.order : null,
      ellipsis: true,
    },
    {
      title: "Actions",
      dataIndex: "action",
      key: "action",
      render: (_, record) => {
        return (
          <Dropdown
            menu={{
              items,
              onClick: handleMenuClick,
            }}
            onClick={() => setRecordId(record.id)}
            trigger={["click"]}
          >
            <a
              onClick={(e) => e.preventDefault()}
              style={{ textDecoration: "none" }}
            >
              <Space>
                Options
                <SlOptions />
              </Space>
            </a>
          </Dropdown>
        );
      },
    },
  ];

  return (
    <>
      <div className="page-container">
        <div className="property-groups main-container">
          <PageHeading heading="Property Groups" />
          <Row>
            <Col span={24}>
              <FilterContainer heading="Filter property groups by using any of the search filters below:">
                <Form
                  labelCol={{ span: 8 }}
                  wrapperCol={{ span: 14 }}
                  colon={false}
                >
                  <Form.Item label="Property Group Name">
                    <Input
                      value={propertyGroupFilter}
                      onChange={(e) => setPropertyGroupFilter(e.target.value)}
                    />
                  </Form.Item>
                  <Form.Item label="Users (email)">
                    <Input
                      value={userEmailFilter}
                      onChange={(e) => setUserEmailFilter(e.target.value)}
                    />
                  </Form.Item>
                  <Form.Item label="Address">
                    <Input
                      value={addressFilter}
                      onChange={(e) => setAddressFilter(e.target.value)}
                    />
                  </Form.Item>
                  <Form.Item label="Zip">
                    <Input
                      value={zipCodeFilter}
                      onChange={(e) => setZipCodeFilter(e.target.value)}
                    />
                  </Form.Item>
                  <Form.Item label="State">
                    <Select
                      showSearch
                      allowClear
                      options={states}
                      placeholder="Select..."
                      value={state}
                      onChange={(value) => setState(value)}
                    />
                  </Form.Item>
                </Form>
              </FilterContainer>
            </Col>
          </Row>
          <div className="property-groups-list">
            <Space
              style={{
                marginBottom: 16,
              }}
            ></Space>
            <Table
              columns={columns}
              dataSource={filteredDataSource}
              onChange={handleChange}
              rowKey={(record) => record.id}
            />
          </div>
          <Footer />
        </div>
      </div>
      <div className="RightSidebar">
        <RightBar RightBarData={PropertyGroupsRightBar} />
      </div>
      {isConfirmationBoxOpen ? (
        <ConfirmationBox setIsConfirmationBoxOpen={setIsConfirmationBoxOpen}>
          <h2>Please Confirm</h2>
          <p className="message">
            Are you sure you want to delete this Property Group??
          </p>
          <div className="action-buttons">
            <button
              className="red"
              onClick={() => deletePropertyGroup(recordId)}
            >
              Deleted
            </button>
            <button
              className="cancel-btn"
              onClick={() => setIsConfirmationBoxOpen(false)}
            >
              Cancel
            </button>
          </div>
        </ConfirmationBox>
      ) : null}
    </>
  );
}

export default PropertyGroups;
